import { useLocation } from "react-router-dom";
import { ShieldAlert } from "lucide-react";
import { usePermissions } from "@/lib/permissions";
import { moduleForPath } from "@/components/layout/navConfig";

/** Shows the page only if the user's role can VIEW its module (Permission Matrix). */
export function PermissionGate({ children, module }) {
  const location = useLocation();
  const { canView, loading } = usePermissions();
  const needed = module !== undefined ? module : moduleForPath(location.pathname);
  if (!needed) return children;
  if (loading) return <p className="text-sm text-muted-foreground">Loading…</p>;
  if (canView(needed)) return children;
  return (
    <div className="mx-auto mt-16 max-w-md rounded-xl border border-border bg-card p-6 text-center" data-testid="no-access">
      <ShieldAlert className="mx-auto h-8 w-8 text-amber-500" />
      <p className="mt-3 font-semibold text-foreground">You don't have access to this page</p>
      <p className="mt-1 text-sm text-muted-foreground">Ask your administrator to give your role access in Administration → Permission Matrix.</p>
    </div>
  );
}
